"use client";

import Image from "next/image";
import { usePathname } from "next/navigation";
import React from "react";

export default function Decoration() {
  const pathname = usePathname();
  return (
    <div className="absolute top-0 right-0  overflow-hidden">
      {pathname.endsWith("/") && (
        <>
          {/* elips */}
          <svg
            width="673"
            height="50"
            viewBox="0 0 673 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute z-10 right-0 bottom-1/4"
          >
            <ellipse
              cx="336.5"
              cy="25"
              rx="336.5"
              ry="25"
              fill="#D9D9D9"
              fillOpacity="0.1"
            />
          </svg>
          {/* building */}
          <Image
            src={"/assets/images/building-dprd.png"}
            alt="building-dprd-reses-pali"
            width={900}
            height={600}
            className="absolute w-[20rem] md:w-[22rem] lg:w-[27rem] xl:w-[43rem] h-auto bottom-[25%] md:bottom-[22%] right-5 z-20"
          />
        </>
      )}

      {/* group */}
      <svg
        // width="874"
        // height="875"
        viewBox="0 0 874 875"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-auto w-[424px] sm:w-[484px] md:w-[474px] lg:w-[574px] xl:w-[874px]"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          opacity="0.563035"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 -0.295388H944.409V817.834C944.409 817.834 988.542 983.34 775.988 748.856C563.434 514.372 328.594 713.121 206.768 607.585C84.9427 502.049 471.468 101.277 333.448 25.7228C195.428 -49.8316 0 -0.295388 0 -0.295388Z"
          fill="#FF9934"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.6021 -1.98634H883.375L883.39 775.285C883.39 775.285 949.743 931.045 752.371 693.75C554.999 456.454 352.091 605.999 246.988 516.06C141.885 426.12 471.079 82.2391 352.005 17.8504C232.931 -46.5384 68.6021 -1.98634 68.6021 -1.98634Z"
          fill="url(#paint0_linear_1675_850)"
        />
        <g opacity="0.240676">
          <ellipse
            cx="637.935"
            cy="323.467"
            rx="13.7766"
            ry="13.4955"
            stroke="white"
            strokeWidth="4.4985"
          />
          <ellipse
            cx="508.609"
            cy="188.512"
            rx="13.7766"
            ry="13.4955"
            stroke="white"
            strokeWidth="4.4985"
          />
          <ellipse
            cx="798.193"
            cy="39.3274"
            rx="22.2113"
            ry="21.758"
            stroke="white"
            strokeWidth="4.4985"
          />
          <ellipse
            cx="435.509"
            cy="340.451"
            rx="8.15353"
            ry="7.98713"
            stroke="white"
            strokeWidth="4.4985"
          />
          <rect
            x="670.433"
            y="180.599"
            width="40.4865"
            height="40.4865"
            transform="rotate(-23 670.433 180.599)"
            stroke="white"
            strokeWidth="4.4985"
          />
          <rect
            x="656.189"
            y="508.397"
            width="23.6171"
            height="23.6171"
            transform="rotate(-23 656.189 508.397)"
            stroke="white"
            strokeWidth="4.4985"
          />
          <rect
            x="511.738"
            y="410.16"
            width="12.3709"
            height="12.3709"
            transform="rotate(-23 511.738 410.16)"
            stroke="white"
            strokeWidth="4.4985"
          />
          <path
            d="M358.676 249.947L357.221 244.516L358.247 244.241L359.702 249.672L365.109 248.224L365.384 249.25L359.977 250.699L361.426 256.105L360.4 256.38L358.951 250.974L353.52 252.429L353.245 251.403L358.676 249.947Z"
            fill="white"
          />
          <path
            d="M667.941 463.626L666.485 458.194L667.512 457.919L668.967 463.351L674.374 461.902L674.649 462.929L669.242 464.377L670.691 469.784L669.665 470.059L668.216 464.652L662.784 466.108L662.509 465.081L667.941 463.626Z"
            fill="white"
          />
          <path
            d="M515.536 305.843L512.748 295.438L514.713 294.912L517.501 305.316L527.858 302.541L528.385 304.507L518.028 307.282L520.803 317.639L518.837 318.166L516.062 307.809L505.658 310.597L505.131 308.631L515.536 305.843Z"
            fill="white"
          />
          <path
            d="M411.224 32.9538L407.77 20.0624L410.205 19.4098L413.66 32.3011L426.492 28.8628L427.144 31.2985L414.312 34.7368L417.751 47.5688L415.315 48.2214L411.877 35.3895L398.985 38.8437L398.333 36.408L411.224 32.9538Z"
            fill="white"
          />
          <path
            d="M829.268 299.549L823.815 279.198L827.66 278.167L833.114 298.519L853.371 293.091L854.401 296.936L834.144 302.364L839.572 322.621L835.727 323.651L830.299 303.394L809.948 308.847L808.917 305.002L829.268 299.549Z"
            fill="white"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1675_850"
            x1="904.015"
            y1="-1201.03"
            x2="-256.219"
            y2="-97.1272"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2E7D32" />
            <stop offset="1" stopColor="#1C4D1F" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
